import {
  ArgumentsHost,
  Catch,
  ExceptionFilter,
  HttpException,
  HttpStatus,
} from '@nestjs/common';
import type { Request, Response } from 'express';

@Catch()
export class HttpExceptionFilter implements ExceptionFilter {
  catch(exception: unknown, host: ArgumentsHost): void {
    const context = host.switchToHttp();
    const response = context.getResponse<Response>();
    const request = context.getRequest<Request>();
    const status =
      exception instanceof HttpException
        ? exception.getStatus()
        : HttpStatus.INTERNAL_SERVER_ERROR;
    const body =
      exception instanceof HttpException ? exception.getResponse() : null;
    const rawMessage =
      typeof body === 'object' && body && 'message' in body
        ? (body as { message: string | string[] }).message
        : typeof body === 'string'
          ? body
          : 'Internal server error';

    response.status(status).json({
      success: false,
      error: {
        statusCode: status,
        message: rawMessage,
        path: request.url,
        timestamp: new Date().toISOString(),
      },
    });
  }
}
